import React from 'react'
import PropTypes from 'prop-types'
import P from '../Typography/P'
import dictionary from '../../../dictionary'

import styles from './radio-group.module.scss'
import LegendsTooltip from './LegendsTooltip'
import LegendsRadioGroup from './LegendsRadioGroup'

/* eslint-disable camelcase */
const density = {
  glossy: 350,
  matte: 350,
  linen_white: 300,
  linen_ivory: 300,
  linen_grey: 260,
  curious_white: 290,
  curious_gold: 290,
  touchcover_white: 300,
  touchcover_ivory: 300,
}
/* eslint-enable camelcase */

function PaperType(props) {
  const { onChange, name, current, content } = props
  return (
    <div className={styles.root}>
      <P size="small" className={styles.legend}>
        Тип бумаги в наличии
      </P>
      <LegendsRadioGroup
        defaultValue={current}
        value={current}
        ariaLabel={name}
        className={styles.group}
        onChange={(value) => onChange(name, value)}
      >
        {content.map(({ value, label, disabled }) => (
          <LegendsTooltip
            key={`${name}-${value}`}
            title={`${dictionary.item[value]} – плотность бумаги ${density[value]} г/м²`}
            disabled={disabled}
          >
            <span
              className={styles.labelImage}
              style={{ backgroundImage: `url(${label})` }}
            />
          </LegendsTooltip>
        ))}
      </LegendsRadioGroup>
    </div>
  )
}

PaperType.propTypes = {
  productName: PropTypes.string,
  name: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  current: PropTypes.string,
  onChange: PropTypes.func,
}

export default PaperType
